import helper from '@/libs/forms';

export default {
  schema: {
    fields: [
      helper.currency('Cash on Hand & In Banks', 'currentCashOnHandInBank', false, 6),
      helper.currency('Stocks & Bonds', 'valueInvestmentPortfolio', false, 6),
      helper.currency('Real Estate - Investments', 'valueRealEstateOwned', false, 6),
      helper.currency('Accounts & Notes Receivable', 'assetAccountsNotesReceivable', false, 6),
      helper.currency('Real Estate - Homestead', 'assetRealEstateHomestead', false, 6),
      helper.currency('IRAs or Other Retirement Accounts', 'assetIraOrOtherRetirement', false, 6),
      helper.currency('Cash Value of Life Insurance', 'assetCashValueLifeInsurance', false, 6),
      helper.currency('Other Assets - Personal Property', 'assetOtherPersonalProperty', false, 6),
      helper.currency('Other Assets - Autos', 'assetOtherAutos', false, 6),
      helper.currency('Notes Receivable', 'assetNotesReceivable', false, 6),
      helper.currency('Misc (Jewelry)', 'assetsMisc', false, 6),
      helper.currency('Other Assets', 'assetOthers', false, 6),
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/resources/schemaAssets.js